import z from 'zod';

const buttonSchema = z.object({
  title: z.string(),
  action: z.string(),
  external: z.boolean(),
});

const flagSchema = z.object({
  title: z.string(),
  color: z.string(),
});

const availableReportSchema = z.object({
  title: z.string(),
  link: z.string(),
  price: z.number(),
  formattedPrice: z.string(),
  flags: z.array(flagSchema),
  summary: z.array(z.string()),
  button: buttonSchema,
});
export type AvailableReport = z.infer<typeof availableReportSchema>;

export const greenlightRegistrationLookupResponseErrorSchema = z.object({
  adId: z.number(),
  errorMessage: z.string(),
});

export const greenlightRegistrationLookupResponseSuccessSchema = z.object({
  adId: z.number(),
  registration: z.string(),
  title: z.string(),
  headerTitle: z.string(),
  link: z.string().optional().nullable(),
  vehicleDetails: z.record(z.string(), z.string()),
  vehicle: z.string(),
  subtitle: z.string().optional().nullable(),
  availableReports: z.array(availableReportSchema),
});

export const greenlightRegistrationLookupResponseSchema = z.union([
  greenlightRegistrationLookupResponseSuccessSchema,
  greenlightRegistrationLookupResponseErrorSchema,
]);

export type GreenlightRegistrationLookupResponse = z.infer<
  typeof greenlightRegistrationLookupResponseSuccessSchema
>;
